module.exports = __webpack_public_path__ + "assets/img/american-express.be4c2cec.svg";